/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";

import { connect } from "react-redux";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() { }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {
  /// Open menu
  componentDidMount() {
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    document.getElementsByClassName("content-body")[0].style.marginLeft =
      "0rem";
    function toggleFunc() {
      console.log("menu-toggle" in aaa.classList, aaa.classList, "classList");
      if (aaa.classList.length == 2) {
        document.getElementsByClassName("content-body")[0].style.marginLeft =
          "2rem";
      } else {
        document.getElementsByClassName("content-body")[0].style.marginLeft =
          "14rem";
      }

      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    toggleFunc();
  }
  state = {
    loveEmoji: false,
    oneBox: "",
    twoBox: "",
    threeBox: "",
  };

  handleClick(value, indexstr, index) {
    console.log(this.state, "valuehandleClick");
    if (indexstr == "dataIndex") {
      console.log(value, indexstr, index, "valuehandleClick");
    } else if (indexstr == "subIndex") {
      this.setState((prevState) => ({
        ...prevState,
        oneBox: prevState.oneBox == value ? "" : value,
      }));
      console.log(value, indexstr, index, "valuehandleClick");
    } else if (indexstr == "index") {
      this.setState((prevState) => ({
        ...prevState,
        twoBox: prevState.twoBox == value ? "" : value,
        oneBox: "",
      }));
      console.log(value, indexstr, index, "valuehandleClick");
    }
  }

  render() {
    /// Path

    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];
    let userDetails = JSON.parse(window.localStorage.getItem("userDetails"));
    console.log("hello MOTO", userDetails);
    console.log(
      "userDetails this.props",
      this.props.sideData,
      userDetails?.rolename
    );

    /// Active menu
    let dashBoard = [
      "",
      "event-list",
      "event",
      "customers",
      "analytics",
      "reviews",
      "task",
    ],
      app = [
        "app-profile",
        "app-calender",
        "email-compose",
        "email-inbox",
        "email-read",
        "ecom-product-grid",
        "ecom-product-list",
        "ecom-product-list",
        "ecom-product-order",
        "ecom-checkout",
        "ecom-invoice",
        "ecom-customers",
        "post-details",
        "ecom-product-detail",
      ],
      gcLogin = [],
      email = ["email-compose", "email-inbox", "email-read"],
      shop = [
        "ecom-product-grid",
        "ecom-product-list",
        "ecom-product-list",
        "ecom-product-order",
        "ecom-checkout",
        "ecom-invoice",
        "ecom-customers",
        "ecom-product-detail",
      ],
      charts = [
        "chart-rechart",
        "chart-flot",
        "chart-chartjs",
        "chart-chartist",
        "chart-sparkline",
        "chart-apexchart",
      ],
      bootstrap = [
        "ui-accordion",
        "ui-badge",
        "ui-alert",
        "ui-button",
        "ui-modal",
        "ui-button-group",
        "ui-list-group",
        "ui-media-object",
        "ui-card",
        "ui-carousel",
        "ui-dropdown",
        "ui-popover",
        "ui-progressbar",
        "ui-tab",
        "ui-typography",
        "ui-pagination",
        "ui-grid",
      ],
      plugins = [
        "uc-select2",
        "uc-nestable",
        "uc-sweetalert",
        "uc-toastr",
        "uc-noui-slider",
        "map-jqvmap",
        //"post",
      ],
      redux = ["todo", "form-redux", "form-redux-wizard"],
      widget = ["widget-basic"],
      forms = [
        "form-element",
        "form-wizard",
        "form-editor-summernote",
        "form-pickers",
        "form-validation-jquery",
      ],
      table = [
        "table-bootstrap-basic",
        "table-datatable-basic",
        "table-sorting",
        "table-filtering",
      ],
      pages = [
        "page-register",
        "page-login",
        "page-lock-screen",
        "page-error-400",
        "page-error-403",
        "page-error-404",
        "page-error-500",
        "page-error-503",
      ],
      error = [
        "page-error-400",
        "page-error-403",
        "page-error-404",
        "page-error-500",
        "page-error-503",
      ];

    // let data = useSelector((state) => {
    //   return state.CommonResponse.sideBarDynamic
    // })

    // console.log(data,"datadatadatadatadata")

    let rolesArray = {
      MPAG: ["Administrator", "Super Admin", "Manage Engineer"],
      MOP: [
        "Administrator",
        "Super Admin",
        "RF Engineer",
        "Development",
        "FOPS",
        "PAG Admin",
        "PAG Engineer",
        "Manage Engineer",
      ],
      MOPCREATE: ["GC Login"],
      RAN: [
        "Administrator",
        "Super Admin",
        "GC Login",
        "RF Engineer",
        "Development",
        "FOPS",
        "PAG Admin",
        "PAG Engineer",
        "T-Mobile Manager",
        "TruNorthe",
        "Manage Engineer",
      ],
      RANFULL: ["Administrator", "Super Admin", "Manage Engineer"],
      IXSupport: ["Super Admin", "Manage Engineer"],
      TTFULL: ["Administrator", "Super Admin", "Manage Engineer"],
      TT: [
        "Administrator",
        "Super Admin",
        "RF Engineer",
        "Development",
        "FOPS",
        "PAG Admin",
        "PAG Engineer",
        "TruNorthe",
        "T-Mobile Manager",
        "Manage Engineer",
      ],
      E911: ["Administrator", "Super Admin", "Manage Engineer"],
      RTT: ["Super Admin", "Manage Engineer"],
      SeventyTwoHours: ["Super Admin", "Manage Engineer"],
      RFPerformance: ["Super Admin", "Manage Engineer", "RF Engineer"],
      RFPerformanceOther: ["Super Admin", "Manage Engineer"],
      RFPerformanceApproval: ["Super Admin", "RF Engineer"],

      ProjectDatabase: ["Super Admin", "Manage Engineer"],
      SuperAdmin: ["Super Admin"],
      PostIXRFSupport: [],
      IXSupportErixcion: [""],
      Reports: [""],
      ChangePassword: [],
      // "ChangePassword":["Administrator","Super Admin","GC Login","RF Engineer","Development","FOPS","PAG Admin","PAG Engineer","T-Mobile Manager","TruNorthe","Manage Engineer"],
      NetworkDatabase: [""],
    };

    // let rolesArray={
    //   "MPAG":["Administrator","Super Admin"],
    //   "MOP":["Administrator","Super Admin","RF Engineer","Development","FOPS","PAG Admin","PAG Engineer"],
    //   "MOPCREATE":["GC Login"],
    //   "RAN":["Administrator","Super Admin","GC Login","RF Engineer","Development","FOPS","PAG Admin","PAG Engineer","T-Mobile Manager","TruNorthe"],
    //   "RANFULL":["Administrator","Super Admin"],
    //   "IXSupport":["Super Admin"],
    //   "TTFULL":["Administrator","Super Admin"],
    //   "TT":["Administrator","Super Admin","RF Engineer","Development","FOPS","PAG Admin","PAG Engineer","TruNorthe","T-Mobile Manager"],
    //   "E911":["Administrator","Super Admin"],
    //   "RTT":["Super Admin"],
    //   "SeventyTwoHours":["Super Admin"],
    //   "RFPerformance":["Super Admin"],
    //   "ProjectDatabase":["Super Admin"],
    //   "SuperAdmin":["Super Admin"],
    //   "PostIXRFSupport":[],
    //   "IXSupportErixcion":[""],
    //   "Reports":[""],
    //   "ChangePassword":[],
    //   // "ChangePassword":["Administrator","Super Admin","GC Login","RF Engineer","Development","FOPS","PAG Admin","PAG Engineer","T-Mobile Manager","TruNorthe","Manage Engineer"],
    //   "NetworkDatabase":[""]
    // }

    console.log(
      rolesArray["MPAG"],
      userDetails?.rolename,
      rolesArray["MPAG"],
      "testing role module"
    );

    return (
      <div className="deznav">
        <PerfectScrollbar className="deznav-scroll">
          <MM className="metismenu" id="menu">
            {console.log("jsndsa", userDetails?.rolename)}
            {/* ============================================NEW SIDEBAR===================================================== */}
            {/* dashbord */}
            {(userDetails?.rolename == "Manage Engineer" &&
              userDetails?.department?.values.includes("DASHBOARD")) ||
              userDetails?.rolename == "sawomemn" ||
              userDetails?.rolename == "Super Admin" ? (
              <Link
                className=" flaticon-381-television ai-icon"
                style={{ fontSize: "15px" }}
                onClick={() => this.props.onClick()}
                to="/mpim/dashboard"
              >
                <span style={{ marginLeft: "0.9rem" }}>DASHBOARD</span>
              </Link>
            ) : (
              ""
            )}
            {/*capex dash  */}
            {(userDetails?.rolename == "Manage Engineer" &&
              userDetails?.department?.values.includes("COP Dashboard")) ||
              userDetails?.rolename == "sawomemn" ||
              userDetails?.rolename == "Super Admin" ? (
              <Link
                className=" flaticon-381-television ai-icon"
                style={{ fontSize: "15px" }}
                onClick={() => this.props.onClick()}
                to="/mpim/CapexDashboard"
              >
                <span style={{ marginLeft: "0.9rem" }}>CAPEX DASHBOARD</span>
              </Link>
            ) : (
              ""
            )}
            {/* CAPEX REPORT */}
            {(userDetails?.rolename == "Manage Engineer" &&
              userDetails?.department?.values.includes("CAPEX REPORT")) ||
              userDetails?.rolename == "sawomemn" ||
              userDetails?.rolename == "Super Admin" ? (
              <Link
                className=" flaticon-381-television ai-icon"
                style={{ fontSize: "15px" }}
                onClick={() => this.props.onClick()}
                to="/mpim/CapexReport"
              >
                <span style={{ marginLeft: "0.9rem" }}>CAPEX REPORT</span>
              </Link>
            ) : (
              ""
            )}
            {(userDetails?.rolename == "Manage Engineer" &&
              userDetails?.department?.values.includes("UTILIZATION")) ||
              userDetails?.rolename == "sawomemn" ||
              userDetails?.rolename == "Super Admin" ? (
              <Link
                className=" flaticon-381-television ai-icon"
                style={{ fontSize: "13px" }}
                onClick={() => this.props.onClick()}
                to="/mpim/Utilization"
              >
                <span style={{ marginLeft: "0.6rem" }}>UTILIZATION</span>
              </Link>
            ) : (
              ""
            )}



            {(userDetails?.rolename == "Manage Engineer" &&
              userDetails?.department?.values.includes("ACCOUNT")) ||
              userDetails?.rolename == "sawomemn" ||
              userDetails?.rolename == "Super Admin" ? (
              <li className={""}>
                <Link className="has-arrow ai-icon" to="">
                  <i className="flaticon-381-television"></i>
                  <span style={{ fontSize: "15px" }} className="nav-text">
                    ACCOUNT
                  </span>
                </Link>

                <ul className="ps-2 pl-2 mm-collapse">
                  {this.props.sideData.map((item, index) => (
                    <li key={index} className={""}>
                      {console.log("app.includes(path):", item)}
                      <div
                        onClick={() => this.handleClick(item._id, "index", index)}
                        className={""}
                      >
                        <a
                          className={`has-arrow ai-icon ${this.state.twoBox != item._id ? "mm-collapsed" : ""
                            }`}
                          to=""
                          aria-expanded={!(this.state.twoBox != item._id)}
                        >
                          <i className="flaticon-381-television"></i>
                          <span style={{ fontSize: "15px" }} className="nav-text">
                            {item._id}
                          </span>
                        </a>
                      </div>

                      <ul
                        className={`ps-2 pl-2 mm-collapse ${this.state.twoBox === item._id ? "mm-show" : ""
                          }`}
                      >
                        {item?.supercategory?.map((itm, subIndex) => (
                          <li
                            key={subIndex}
                            className={
                              this.state.twoBox === itm._id ? "mm-active" : ""
                            }
                          >
                            <div
                              onClick={() =>
                                this.handleClick(itm.market, "subIndex", subIndex)
                              }
                              className={""}
                            >
                              <a
                                className={`has-arrow ai-icon ${this.state.oneBox != itm.market
                                  ? "mm-collapsed"
                                  : ""
                                  }`}
                                to=""
                                aria-expanded={!(this.state.oneBox != itm.market)}
                              >
                                <i className="flaticon-381-television"></i>
                                <span
                                  style={{ fontSize: "15px" }}
                                  className="nav-text "
                                >
                                  {itm.market}
                                </span>
                              </a>
                            </div>

                            <ul
                              className={`ps-2 pl-2 mm-collapse ${this.state.oneBox === itm.market ? "mm-show" : ""
                                }`}
                            >
                              {itm?.data?.map((dataItem, dataIndex) => (
                                <li
                                  key={dataIndex}
                                  onClick={() =>
                                    this.handleClick(
                                      dataItem,
                                      "dataIndex",
                                      dataIndex
                                    )
                                  }
                                  className={
                                    this.state.oneBox === item.market
                                      ? "mm-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    className=""
                                    to={
                                      "/mpim/" +
                                      dataItem?.replaceAll(" ", "")?.toLowerCase()
                                    }
                                  >
                                    <span
                                      style={{ fontSize: "15px" }}
                                      className="nav-text"
                                    >
                                      {dataItem}
                                    </span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </li>
            ) : (
              ""
            )}

            {/* account */}


            {/* ================================================MPIM ERICSSON START================================================= */}


            {(userDetails?.rolename == "Manage Engineer" &&
              userDetails?.department?.values.includes("mPim Ericsson Tool")) ||
              userDetails?.rolename == "Super Admin" ? (
              <li className={`${dashBoard.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  <i className="flaticon-381-networking"></i>
                  <span style={{ fontSize: "15px" }} className="nav-text">
                    mPIM ERICSSON
                  </span>
                </Link>
                <ul>
                  <li>
                    <Link
                      style={{ fontSize: "13px" }}
                      className={`${path === "app-calender" ? "mm-active" : ""
                        }`}
                      to="/mpim/runmpim"
                      onClick={() => this.props.onClick3()}
                    >
                      Run mPIM
                    </Link>
                    <Link
                      style={{ fontSize: "13px" }}
                      className={`${path === "app-calender" ? "mm-active" : ""
                        }`}
                      to="/mpim/viewmpimreports"
                      onClick={() => this.props.onClick3()}
                    >
                      View mPIM Reports
                    </Link>
                    <Link
                      style={{ fontSize: "13px" }}
                      className={`${path === "app-calender" ? "mm-active" : ""
                        }`}
                      to="/mpim/Runmheatmap"
                      onClick={() => this.props.onClick3()}
                    >
                      Run mHeat Map
                    </Link>
                    {/* <Link style={{ fontSize: "13px" }} className={`${path === "app-calender" ? "mm-active" : ""}`} to="/mpim/viewmheatreports" onClick={() => this.props.onClick3()}>View MHeat Reports</Link> */}
                    <Link
                      style={{ fontSize: "13px" }}
                      className={`${path === "app-calender" ? "mm-active" : ""
                        }`}
                      to="/mpim/viewmheatreports"
                      onClick={() => this.props.onClick3()}
                    >
                      View mHeat Map Reports
                    </Link>

                    {/* <Link style={{ fontSize: "13px" }} className={`${path === "app-calender" ? "mm-active" : ""}`} to="/mpim/runmpimrssi" onClick={() => this.props.onClick3()}>RUN MPIM RSSI</Link> */}
                    {/* <Link style={{ fontSize: "13px" }} className={`${path === "awsdashboard" ? "mm-active" : ""}`} to="/PAG/aws/dashboard" onClick={() => this.props.onClick3()}>abc</Link> */}

                    {/* <Link style={{ fontSize: "13px" }} className={`${path === "app-calender" ? "mm-active" : ""}`} to="/mpim/viewmpimrssireports" onClick={() => this.props.onClick3()}>View MPIM RSSI Reports</Link> */}
                  </li>
                </ul>
              </li>
            ) : (
              ""
            )}

            {/* ==============================================MPIM ERICSSON END================================================= */}
            {/* ================================================MPIM NOKIA START================================================= */}

            <>
              {userDetails ? (
                <>
                  <>
                    {rolesArray["MOPCREATE"].indexOf(userDetails?.rolename) !=
                      -1 && userDetails?.mopAccess ? (
                      <li
                        className={`${gcLogin.includes(path) ? "mm-active" : ""
                          }`}
                      >
                        <Link className="has-arrow ai-icon" to="/PAG/Network">
                          <i className="flaticon-381-television"></i>
                          {/* <span style={{ fontSize: "15px" }} className="nav-text">MPIM NOKIA</span> */}
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {(userDetails?.rolename == "Manage Engineer" &&
                      userDetails?.department?.values.includes("mPim Nokia Tool")) ||

                      userDetails?.rolename == "Super Admin" ? (
                      <li
                        className={`${gcLogin.includes(path) ? "mm-active" : ""
                          }`}
                      >
                        <Link className="has-arrow ai-icon" to="/PAG/Network">
                          <i className="flaticon-381-television"></i>
                          <span
                            style={{ fontSize: "15px" }}
                            className="nav-text"
                          >
                            mPIM NOKIA
                          </span>
                        </Link>
                        <ul>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "/mpim/runnokiampim" ? "mm-active" : ""
                                }`}
                              to="/mpim/runnokiampim"
                            >
                              Run Nokia mPIM
                            </Link>
                          </li>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "/mpim/viewnokiampimreports"
                                ? "mm-active"
                                : ""
                                }`}
                              to="/mpim/viewnokiampimreports"
                            >
                              View Nokia mPIM Reports
                            </Link>
                          </li>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "/mpim/runrtwp" ? "mm-active" : ""
                                }`}
                              to="/mpim/runrtwp"
                            >
                              Run RTWP
                            </Link>
                          </li>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "/mpim/viewrtwpreports"
                                ? "mm-active"
                                : ""
                                }`}
                              to="/mpim/viewrtwpreports"
                            >
                              View RTWP Reports
                            </Link>
                          </li>
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "/mpim/runnokiampimrssi" ? "mm-active" : ""}`} to="/mpim/runnokiampimrssi" >Run MPIM RSSI</Link></li>
                          <li><Link style={{ fontSize: "13px" }} className={`${path === "/mpim/viewnokiampimreports" ? "mm-active" : ""}`} to="/mpim/viewnokiampimrssireports" >View MPIM RSSI Reports</Link></li> */}
                        </ul>
                      </li>
                    ) : (
                      ""
                    )}




                  </>

                  {/* ================================================MOP END================================================= */}

                  {/* ================================================RAN START================================================= */}

                  {/* ##############################sidebar start########################? */}

                  {/* ############################## end start########################? */}
                  {/* dashBoard########################################################### */}

                  {/* end dashBoard33333333333333333333 */}
                  {/* <>
                    {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RAN SUPPORT")) || rolesArray["RAN"].indexOf(userDetails?.rolename) != -1 ?
                      <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                        <Link className="has-arrow ai-icon" to="#" >
                          <i className="flaticon-381-television"></i>
                          <span style={{ fontSize: "15px" }} className="nav-text">RAN Support</span>
                        </Link>
                        <ul >
                          <li>
                            <Link style={{ fontSize: "13px" }}
                              className={`${path === "app-profile" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()}
                              to="/PAG/ran/support/dashboard">
                              RAN Dashboard
                            </Link>
                          </li>

                          {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RAN SUPPORT")) || rolesArray["RANFULL"].indexOf(userDetails?.rolename) != -1 ?
                            <>
                              <li>
                                <Link style={{ fontSize: "13px" }}
                                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                                  onClick={() => this.props.onClick()}
                                  to="/PAG/ran/support/tracker"
                                >
                                  RAN Tracker
                                </Link>
                              </li>
                              <li>
                                <Link style={{ fontSize: "13px" }}
                                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                                  onClick={() => this.props.onClick()}
                                  to="/PAG/ran/support/dailyReport"
                                >
                                  Daily Activity Report
                                </Link>
                              </li>
                              <li>
                                <Link style={{ fontSize: "13px" }}
                                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                                  onClick={() => this.props.onClick()}
                                  to="/PAG/ran/sla/report"
                                >
                                  SLA Report
                                </Link>
                              </li>
                              <li>
                                <Link style={{ fontSize: "13px" }}
                                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                                  onClick={() => this.props.onClick()}
                                  to="/PAG/ran/executivespillover/report"
                                >
                                  Executive Spillover Report
                                </Link>
                              </li>
                              <li>
                                <Link style={{ fontSize: "13px" }}
                                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                                  onClick={() => this.props.onClick()}
                                  to="/PAG/ran/nestingTime/report"
                                >
                                  Nesting Report
                                </Link>
                              </li>
                              <li>
                                <Link style={{ fontSize: "13px" }}
                                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                                  onClick={() => this.props.onClick()}
                                  to="/PAG/ran/nestingTime/tracker"
                                >
                                  Nesting Tracker
                                </Link>
                              </li>

                            </> : ""}
                        </ul>
                      </li> : ""}
                  </> */}

                  {/* ================================================RAN END================================================= */}

                  {/* ================================================IX Support Start================================================== */}
                  {/* <>
                  {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("IX SUPPORT")) || rolesArray["IXSupport"].indexOf(userDetails?.rolename) != -1 ? <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                    <Link className="has-arrow ai-icon" to="#" >


                      <i className="flaticon-381-television"></i>
                      <span style={{ fontSize: "15px" }} className="nav-text">IX Support</span>
                    </Link>
                    <ul >

                      

                      <li>
                        <Link style={{ fontSize: "13px" }}
                          className={`${path === "app-calender" ? "mm-active" : ""}`}
                          onClick={() => this.props.onClick()}
                          to="/Mpim/RunMpin"
                        >
                          Run Mpim
                        </Link>
                      </li>


                   

                      <li>
                        <Link style={{ fontSize: "13px" }}
                          className={`${path === "app-calender" ? "mm-active" : ""}`}
                          onClick={() => this.props.onClick()}
                          to="/PAG/ix/calender"
                        >
                          IX Calendar
                        </Link>
                      </li>
                     
                      <li>
                        <Link style={{ fontSize: "13px" }}
                          className={`${path === "app-calender" ? "mm-active" : ""}`}
                          onClick={() => this.props.onClick()}
                          to="/PAG/ix/dashboard"
                        >
                          IX Dashboard
                        </Link>
                      </li>
                    </ul>

                  </li> : ""}

</> */}
                  {/* ================================================IX Support End================================================== */}

                  {/* ================================================TT START================================================= */}

                  {/* {rolesArray["TT"].indexOf(userDetails?.rolename) != -1 || (userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("TROUBLE TICKET")) ?
                    <>
                      <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                        <Link className="has-arrow ai-icon" to="#" >
                          <i className="flaticon-381-television"></i>
                          <span style={{ fontSize: "15px" }} className="nav-text">Trouble Tickets</span>
                        </Link>
                        <ul >
                          <li>
                            <Link style={{ fontSize: "13px" }}
                              className={`${path === "app-profile" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()}
                              to="/PAG/troubleTickets/dashboard">
                              TT Dashboard
                            </Link>
                          </li>
                          {rolesArray["TTFULL"].indexOf(userDetails?.rolename) != -1 || (userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("TROUBLE TICKET")) ?
                            <li>
                              <Link style={{ fontSize: "13px" }}
                                className={`${path === "app-calender" ? "mm-active" : ""}`}
                                onClick={() => this.props.onClick()}
                                to="/PAG/troubleTickets/tracker"
                              >
                                TT Tracker
                              </Link>
                            </li> : ""}
                        </ul>
                      </li>
                    </>
                    : ""
                  } */}

                  {/* ================================================TT END================================================= */}

                  {/* ================================================E911 START================================================= */}

                  {/* {rolesArray["E911"].indexOf(userDetails?.rolename) != -1 || (userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("E911 CALL TEST")) ?
                    <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                      <Link className="has-arrow ai-icon" to="#" >
                        <i className="flaticon-381-television"></i>
                        <span style={{ fontSize: "13px" }} className="nav-text">E911 Call Test</span>
                      </Link>
                      <ul >
                        <li>
                          <Link style={{ fontSize: "13px" }}
                            className={`${path === "app-profile" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/E911/dashboard">
                            E911 DashBoard
                          </Link>
                        </li>
                        <li>
                          <Link style={{ fontSize: "13px" }}
                            className={`${path === "app-calender" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/E911/Tracker"
                          >
                            E911 Tracker
                          </Link>
                        </li>
                      </ul>
                    </li>

                    : ""
                  } */}

                  {/* ================================================E911 END================================================= */}

                  {/* ================================================RTT START================================================= */}

                  {/* {rolesArray["RTT"].indexOf(userDetails?.rolename) != -1 || (userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RTT")) ?

                    <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                      <Link className="has-arrow ai-icon" to="#" >
                        <i className="flaticon-381-television"></i>
                        <span style={{ fontSize: "15px" }} className="nav-text">RTT</span>
                      </Link>
                      <ul >
                        <li>
                          <Link style={{ fontSize: "13px" }}
                            className={`${path === "app-profile" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/rtt/dashboard">
                            DashBoard
                          </Link>
                        </li>
                      </ul>
                    </li>

                    : ""}
 */}

                  {/* ================================================RTT END================================================= */}

                  {/* =============ss===================================72 Hours Alarm  START================================================= */}

                  {/* {userDetails?.rolename == "Super Admin" || userDetails?.rolename == "Administrator" ?  */}
                  {/* {1==1/  */}

                  {/* {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("SEVENTY TWO")) || rolesArray["SeventyTwoHours"].indexOf(userDetails?.rolename) != -1 ?
                    <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                      <Link className="has-arrow ai-icon" to="#" >
                        <i className="flaticon-381-television"></i>
                        <span style={{ fontSize: "15px" }} className="nav-text">72 Hours Alarm</span>
                      </Link>
                      <ul >
                        <li>
                          <Link style={{ fontSize: "13px" }}
                            className={`${path === "app-profile" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/72alarm/dashboard">
                            DashBoard
                          </Link>
                        </li>
                       
                      </ul>
                    </li> : ""} */}
                  {/* ================================================72 Hours END================================================= */}

                  {/* ================================================RF Performance Start================================================== */}
                  {/* {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RF PERFORMANCE")) || rolesArray["RFPerformance"].indexOf(userDetails?.rolename) != -1 ?

                    <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                      <Link className="has-arrow ai-icon" to="#" >
                        <i className="flaticon-381-television"></i>
                        <span style={{ fontSize: "15px" }} className="nav-text">RF Performance </span>
                      </Link>
                      <ul >

                        {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RF PERFORMANCE_OTHER")) || rolesArray["RFPerformanceOther"].indexOf(userDetails?.rolename) != -1 ?
                          <li>
                            <Link style={{ fontSize: "13px" }}
                              className={`${path === "app-profile" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()}
                              to="/PAG/ssv/dashboard">
                              SSV Dashboard
                            </Link>
                          </li> : ""
                        }

                        {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RF PERFORMANCE_APPROVAL")) || rolesArray["RFPerformanceApproval"].indexOf(userDetails?.rolename) != -1 ?

                          <li>
                            <Link style={{ fontSize: "13px" }}
                              className={`${path === "app-profile" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()}
                              to="/PAG/ssv/Approval/dashboard">
                              SSV Approval
                            </Link>
                          </li> : ""}


                        {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RF PERFORMANCE_OTHER")) || rolesArray["RFPerformanceOther"].indexOf(userDetails?.rolename) != -1 ?

                          < li >
                            <Link style={{ fontSize: "13px" }}
                              className={`${path === "app-calender" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()}
                              to="/PAG/launchSSSNNP/dashboard"
                            >
                              Launch, SSS & NNP
                            </Link>
                          </li> : ""}

                        {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("RF PERFORMANCE_APPROVAL")) || rolesArray["RFPerformanceApproval"].indexOf(userDetails?.rolename) != -1 ?

                          < li >
                            <Link style={{ fontSize: "13px" }}
                              className={`${path === "app-calender" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()}
                              to="/PAG/launchSSSNNP/Approval/dashboard"
                            >
                              SSS Approval
                            </Link>
                          </li> : ""}
                      

                      </ul>
                    </li>
                    : ""} */}

                  {/* ================================================RF Performance End================================================== */}

                  {/* ================================================Project Database START================================================= */}

                  {/* {1==2 ?  */}
                  {/* {(userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("NETWORK DATABASE")) || rolesArray["ProjectDatabase"].indexOf(userDetails?.rolename) != -1 ?
                    <>

                      <li className={`${redux.includes(path) ? "mm-active" : ""}`}>

                        <Link className="has-arrow ai-icon" to="#" >
                          <i className="flaticon-381-book"></i><span style={{ fontSize: "15px" }} className="nav-text">Network Database</span>
                        </Link>
                        <ul>
                          <li><Link className={`${path === "networkDatabase" ? "mm-active" : ""}`} to="/networkDatabase">Network Database</Link></li>
                          <li><Link style={{ fontSize: "13px" }} className={`${path === "inflight" ? "mm-active" : ""}`} to="/inflight">Inflight Database</Link></li>
                          <li><Link style={{ fontSize: "13px" }} className={`${path === "magenta" ? "mm-active" : ""}`} to="/magenta">Magenta Database</Link></li>
                          <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/network/database" ? "mm-active" : ""}`} to="/PAG/network/database">Project Database</Link></li>



                        </ul>
                      </li>
                    </>
                    : ""} */}

                  {/* { rolesArray["NetworkDatabase"].indexOf(userDetails?.rolename)!=-1 || (userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("Network")) ? */}
                  {/* <>

                      <li className={`${redux.includes(path) ? "mm-active" : ""}`}>

                        <Link className="has-arrow ai-icon" to="#" >
                          <i className="flaticon-381-book"></i><span style={{ fontSize: "15px" }} className="nav-text">Network Database</span>
                        </Link>
                        <ul>
                          <li><Link className={`${path === "networkDatabase" ? "mm-active" : ""}`} to="/networkDatabase">Network Database</Link></li>
                        </ul>
                      </li>
                    </>
                    : ""} */}

                  {/* ================================================Project Database END================================================= */}

                  {/* ================================================Super Admin START================================================= */}

                  {(userDetails?.rolename == "Manage Engineer" &&
                    userDetails?.department?.values.includes("SUPER ADMIN")) ||
                    rolesArray["SuperAdmin"].indexOf(userDetails?.rolename) !=
                    -1 ||
                    userDetails?.rolename == "sawomemn" ||
                    userDetails.manageadmin == "Granted" ? (
                    <>
                      <li
                        className={`${redux.includes(path) ? "mm-active" : ""}`}
                      >
                        <Link className="has-arrow ai-icon" to="#">
                          <i className="flaticon-381-book"></i>
                          <span
                            style={{ fontSize: "15px" }}
                            className="nav-text"
                          >
                            ADMIN
                          </span>
                        </Link>
                        <ul>
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "todo" ? "mm-active" : ""}`} to="#">App SignUp Request</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manage/account" ? "mm-active" : ""}`} to="/PAG/manage/account">Manage Account</Link></li> */}
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "mpim/manage/account"
                                ? "mm-active"
                                : ""
                                }`}
                              to="/mpim/manage/account"
                            >
                              Manage Account
                            </Link>
                          </li>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "PAG/manage/market" ? "mm-active" : ""
                                }`}
                              to="/PAG/manage/market"
                            >
                              Manage Markets{" "}
                            </Link>
                          </li>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "mpim/manage/GcCompany"
                                ? "mm-active"
                                : ""
                                }`}
                              to="/mpim/manage/GcCompany"
                            >
                              Manage GC Company
                            </Link>
                          </li>
                          {/* <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "mpim/manage/Gc" ? "mm-active" : ""
                                }`}
                              to="/mpim/manage/Gc"
                            >
                              Manage GC
                            </Link>
                          </li> */}

                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "mpim/manage/site" ? "mm-active" : ""
                                }`}
                              to="/mpim/manage/site"
                            >
                              Manage Site
                            </Link>
                          </li>
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "mpim/manageEngineer"
                                ? "mm-active"
                                : ""
                                }`}
                              to="/mpim/manageEngineer"
                            >
                              Manage Engineers{" "}
                            </Link>
                          </li>

                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "/PAG/manage/managesites" ? "mm-active" : ""}`} to="/PAG/manage/managesites">Manage Sites</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "/PAG/manage/managegc" ? "mm-active" : ""}`} to="/PAG/manage/managegc">Manage Gc</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/userAccount" ? "mm-active" : ""}`} to="/PAG/userAccount">Manage User</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manage/vendor" ? "mm-active" : ""}`} to="/PAG/manage/vendor">Manage Vendor</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Manage Vendor score card</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manage/crewcompany" ? "mm-active" : ""}`} to="/PAG/manage/crewcompany">Manage Crews Company</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/userCrew" ? "mm-active" : ""}`} to="/PAG/userCrew">Manage Crew</Link></li> */}
                          {/* <li><Link className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/PAG/manage/rfds">Manage RFDS</Link></li> */}
                          <li>
                            <Link
                              style={{ fontSize: "13px" }}
                              className={`${path === "form-redux-wizard" ? "mm-active" : ""
                                }`}
                              to="/PAG/manage/technology"
                            >
                              Manage Technology
                            </Link>
                          </li>
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/T-Mobile" ? "mm-active" : ""}`} to="/PAG/T-Mobile">TMO Deployment Managers</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/Tier" ? "mm-active" : ""}`} to="/PAG/Tier">Manager Tier</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manageEngineer" ? "mm-active" : ""}`} to="/PAG/manageEngineer">Manage Engineers </Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manageSites" ? "mm-active" : ""}`} to="/PAG/manageSites">Manage Sites </Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/ManageSite" ? "mm-active" : ""}`} to="/PAG/ManageSite">Manage Site</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manage/ttPIERGroup" ? "mm-active" : ""}`} to="/PAG/manage/ttPIERGroup">Manage Pier TT Group</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/PAG/manage/oss">Manage OSS</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/PAG/manage/utilization">Manage Utilization</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Upload Master</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/PAG/manage/cr">Manage Cr Number</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Manage Mail Center</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/PAG/manage/dropDown">Manage Dropdown List</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manage/MOPInstruction" ? "mm-active" : ""}`} to="/PAG/manage/MOPInstruction">Manage MOP Instruction</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "PAG/manage/MOPInstruction" ? "mm-active" : ""}`} to="/PAG/manage/MOPInstruction">Manage Site Access</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Manage KPI Graph</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Manage Automate Report</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Master Password </Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/PAG/manage/geoFencing">Manage Mobile Geofencing</Link></li> */}
                          {/* <li><Link style={{ fontSize: "13px" }} className={`${path === "form-redux-wizard" ? "mm-active" : ""}`} to="/form-redux-wizard">Manage Old Records</Link></li> */}
                        </ul>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {/* ================================================Super Admin END================================================= */}

                  {/* ================================================Post IX RF Support START================================================= */}

                  {/* {userDetails?.rolename == "Administrator" || (userDetails?.rolename == "Manage Engineer" && userDetails?.department?.values.includes("POSTIX")) ? */}
                  {(userDetails?.rolename == "Manage Engineer" &&
                    userDetails?.department?.values.includes(
                      "POST IX RF SUPPORT"
                    )) ||
                    rolesArray["PostIXRFSupport"].indexOf(
                      userDetails?.rolename
                    ) != -1 ? (
                    <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                      <Link className="has-arrow ai-icon" to="#">
                        <i className="flaticon-381-television"></i>
                        <span style={{ fontSize: "15px" }} className="nav-text">
                          Post IX RF Support
                        </span>
                      </Link>
                      <ul>
                        <li>
                          <Link
                            style={{ fontSize: "13px" }}
                            className={`${path === "app-profile" ? "mm-active" : ""
                              }`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/post-ix-rf/support/dashboard"
                          >
                            POST IX RF SUPPORT Dashboard
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ fontSize: "13px" }}
                            className={`${path === "app-calender" ? "mm-active" : ""
                              }`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/post-ix-rf/support/tracker"
                          >
                            Post IX RF Support Tracker
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ fontSize: "13px" }}
                            className={`${path === "app-calender" ? "mm-active" : ""
                              }`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/kpi/degradedSite/dashboard"
                          >
                            KPI Degraded Sites Dashboard
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ fontSize: "13px" }}
                            className={`${path === "app-calender" ? "mm-active" : ""
                              }`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/post-ix-rf/onAir"
                          >
                            On Air
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ fontSize: "13px" }}
                            className={`${path === "app-calender" ? "mm-active" : ""
                              }`}
                            onClick={() => this.props.onClick()}
                            to="/PAG/post-ix-rf/closeoutReport"
                          >
                            Closeout Report
                          </Link>
                        </li>
                      </ul>
                    </li>
                  ) : (
                    ""
                  )}

                  {/* ================================================Post IX RF Support END================================================= */}

                  {/* ================================================Reports START================================================= */}

                  {/* {userDetails?.rolename == "Administrator" ? */}
                  {(userDetails?.rolename == "Manage Engineer" &&
                    userDetails?.department?.values.includes("REPORTS")) ||
                    rolesArray["Reports"].indexOf(userDetails?.rolename) != -1 ? (
                    <li
                      className={`${charts.includes(path) ? "mm-active" : ""}`}
                    >
                      <Link className="has-arrow ai-icon" to="#">
                        <i className="flaticon-381-controls-3"></i>
                        <span style={{ fontSize: "15px" }} className="nav-text">
                          Reports
                        </span>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}

                  {/* ================================================Reports END================================================= */}

                  {/* ================================================Change Password START================================================= */}

                  {/* {userDetails?.rolename == "Super Admin" ? */}
                  {(userDetails?.rolename == "Manage Engineer" &&
                    userDetails?.department?.values.includes(
                      "CHANGE PASSWORD"
                    )) ||
                    rolesArray["ChangePassword"].indexOf(userDetails?.rolename) !=
                    -1 ? (
                    <li
                      className={`${path === "change-password" ? "mm-active" : ""
                        }`}
                    >
                      <Link to="/PAG/ChangePassword" className="ai-icon">
                        <i className="flaticon-381-settings-2"></i>
                        <span style={{ fontSize: "15px" }} className="nav-text">
                          Change Password
                        </span>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}

                  {/* ================================================Change Password END================================================= */}
                </>
              ) : (
                ""
              )}
            </>
          </MM>
        </PerfectScrollbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state, "statesidebarstate");
  return {
    sideData: state.CommonResponse.sideBarDynamic,
  };
};

export default connect(mapStateToProps)(SideBar);
